import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import BookingPopup from '../../components/BookingPopup';

export default function PricingSustainbilty({extraClass=""}) {
   const [showSerachEngine, setshowSerachEngine] = useState(false);
  return (
    <>
      <div className={`pricing-sustainbilty-sec ${extraClass}`}>
        <div className="sustain-shadow">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-9">
                <div className="sustain-heading">
                  <h2 className="heading">Take action for a sustainable <br />tomorrow</h2>
                </div>
              </div>
              <div className="col-md-12 col-lg-3">
                <div className="sustain-btn">
                  <Link onClick={() => setshowSerachEngine(true)}  className="theme-btn "> <span className="color-overlay" ></span><span className="btn-txt" >Book Us Online</span></Link>
                  <Link to="tel:+1 780 230 1359" className="theme-btn theme-btn2 "><span className="color-overlay" ></span> <span className="btn-txt">Call Us +1 780 230 1359</span></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>
  )
}
